import { create } from 'zustand';

const useDialogStore = create((set) => ({
  // File dialog
  showFileDialog: false,
  setShowFileDialog: (value) => set({ showFileDialog: value }),

  // Text to speech dialog
  showTextSpeechDialog: false,
  setShowTextSpeechDialog: (value) => set({ showTextSpeechDialog: value }),

  // Clear dialog
  showClearDialog: false,
  setShowClearDialog: (value) => set({ showClearDialog: value }),

  // Capabilities dialog
  showCapabilitiesDialog: false,
  setShowCapabilitiesDialog: (value) => set({ showCapabilitiesDialog: value }),

  // Warning dialog
  showWarningDialog: false,
  setShowWarningDialog: (value) => set({ showWarningDialog: value }),

  // Limit dialog
  showLimitDialog: false,
  setShowLimitDialog: (value) => set({ showLimitDialog: value }),

  // Delete dialog
  showDeleteDialog: false,
  setShowDeleteDialog: (value) => set({ showDeleteDialog: value }),

  // Edit dialog
  showEditDialog: false,
  setShowEditDialog: (value) => set({ showEditDialog: value }),

  // Download dialog
  showDownloadDialog: false,
  setShowDownloadDialog: (value) => set({ showDownloadDialog: value }),

  // Image modal attachments
  showImageModalAttachments: false,
  setShowImageModalAttachments: (value) =>
    set({ showImageModalAttachments: value }),
}));

export default useDialogStore;
